var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"geofence-list"},[_c('header-mobile-page',{attrs:{"label":"Our Locations"}}),_c('geofence-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }